import { useState } from 'react';

// poor man's useOptimistic until it's available in react (18.3?)
/**
 * Update a value optimistically, but reset when source of truth changes
 *
 * @param value source of truth value, changing this will reset the optimistic value
 */
const useOptimistic = <T>(value: T) => {
  const [state, setState] = useState<T>(value);
  const [prevValue, setPrevValue] = useState<T>(value);
  if (!Object.is(value, prevValue)) {
    setPrevValue(value);
    setState(value);
  }

  return [state, setState] as const;
};

export default useOptimistic;
